import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { delay, Observable, of } from 'rxjs';
import { UseeActivityStatus } from '../shared/models/useractivitystatus';
import { UserActivityService } from '../shared/services/UserActivityService';
import { LocalStorageService } from '../utility/localStorageService';
import { BsModalRef, BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { ForgotPasswordDialogComponent } from '../shared/dialogs/forgot-password-dialog/forgot-password-dialog.component';
import { NotificationService } from '../notification.service';
import { HttpErrorResponse } from '@angular/common/http';
import { UserLogin } from '../shared/models/user-login';
import { environment } from 'src/environments/environment';
import { loginSuccess } from '../../jsFunctions.js'
import { AuthService } from '../utility/AuthService';
import { decode } from 'querystring';
import { NotesService } from '../shared/services/calls.services';
import { PermissionService } from '../utility/PermissionService';
import { MenuService } from '../utility/MenuService';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  userLogin: UserLogin;
  submitted: boolean = false
  loginForm!: FormGroup;
  showUserIdError: boolean = false;
  showPasswordError: boolean = false
  useractivitystatus: UseeActivityStatus;
  isRememberChecked: boolean = false

  modalRef: BsModalRef;
  userType: string;
  menuItems: any[] = [];

  constructor(private fb: FormBuilder, private router: Router,
    private userActivityService: UserActivityService,
    private localStorage: LocalStorageService,
    private modalService: BsModalService,
    private notifyService: NotificationService,
    private authService: AuthService,
    private persistenceService: LocalStorageService,
    private permissionService: PermissionService,
    private notesService: NotesService,
    private menuService: MenuService,
  ) {
    this.persistenceService.set("token", "NA")
  }

  ngOnInit(): void {
    this.persistenceService.set("token", "NA")
    this.userType = this.localStorage.get("userType")
    this.userActivityService.getCountries()
      .subscribe(
        resp => {
          console.log(resp)
        });


    this.loginForm = this.fb.group({
      remember: [false, Validators.nullValidator],
      userName: ['', [Validators.required, Validators.email]],
      passWord: ['', [Validators.required, Validators.minLength(6)]]
    });
    if (this.localStorage.get("email") != "NA" && this.localStorage.get("password") != "NA") {
      this.loginForm.get('userName').setValue(this.localStorage.get("email"));
      this.loginForm.get('passWord').setValue(this.localStorage.get("password"));
      this.loginForm.get('remember').setValue(true)
      if (this.localStorage.get("logout") == "false") {
        this.localStorage.set("logout", "false")
        this.onSubmit();
      }

    }

  }

  get loginData() {
    return this.loginForm.controls;
  }
  onChange(event: Event): void {
    this.isRememberChecked = event.target['checked'];
  }
  onSubmit() {

    this.userLogin = new UserLogin()
    this.submitted = true;

    if (this.loginForm.valid) {

      this.userLogin.userName = this.loginForm.get('userName')?.value;
      this.userLogin.password = this.loginForm.get('passWord')?.value;

      if (this.persistenceService.get("idleTime") == null || this.persistenceService.get("idleTime") == undefined) {
        this.userLogin.idleTime = 10
      }
      else {
        this.userLogin.idleTime = Number(this.persistenceService.get("idleTime"))
      }
      this.userActivityService.getUserAllowedOrNotByEmailIdAndPassword(this.userLogin)
        .subscribe(
          resp => {
            if (resp == null) {
              this.notifyService.showError("Wrong User Name/Password", "Error")
              return;
            }
            try {
              let decodeDat = this.authService.decodeToken(resp)
              this.useractivitystatus = this.authService.getUserDetails();
              this.localStorage.set("token", resp);
              this.localStorage.set("name", this.useractivitystatus.name);
              this.localStorage.set("userName", this.useractivitystatus.userName);
              this.localStorage.set("refNo", this.useractivitystatus.refNo);
              this.localStorage.set("userType", this.useractivitystatus.userType);
              this.localStorage.set("showMeUpcomingEventsOf", this.useractivitystatus.showMeUpcomingEventsOf.toString());
              this.localStorage.set("showMeLeadsFromDate", this.useractivitystatus.showMeLeadsFromDate);
              this.localStorage.set("sendWhatsAppFrom", this.useractivitystatus.sendWhatsAppFrom);
              this.localStorage.set("sendSMSFrom", this.useractivitystatus.sendSMSFrom);
              this.localStorage.set("sendEMailFrom", this.useractivitystatus.sendEMailFrom);
              this.localStorage.set("accessSource", this.useractivitystatus.accessSource);

              if (this.loginForm.get('remember').value) {
                this.localStorage.set("email", this.userLogin.userName);
                this.localStorage.set("password", this.userLogin.password);
              }
              else {
                this.localStorage.set("email", "NA");
                this.localStorage.set("password", "NA");
              }

              this.notesService.getMenus().subscribe({
                next: (data) => {
                  if (data) {
                    this.menuService.setMenus(data);
                    this.menuItems = data;
                    this.permissionService.setPermissions(this.menuItems);
                    this.localStorage.set('menus', JSON.stringify(this.menuItems));
                  }
                },
                error: (err) => console.error('Error fetching menu:', err)
              });



              of(true)
                .pipe(delay(2000))
                .subscribe(() => {
                  console.log("After 2 seconds");
                  if (this.useractivitystatus.userType == "Admin" || this.useractivitystatus.userType == "Counsellor") {
                    window.location.href = window.location.origin + "/dashboard"
                  }
                  else
                    window.location.href = "/source-wise-lead-status"
                  this.clear();
                  if (this.getOS() == "Android")
                    loginSuccess(this.userLogin.userName)
                });
            } catch (error) {
              alert('Invalid token' + error);
            }
          },
          (error: HttpErrorResponse) => {

          });
    }
    else {
      this.notifyService.showError("Please Enter User Name and Valid Password", "Error")
    }
  }

  clear() {
    this.loginForm.patchValue({
      userName: '',
      passWord: ''
    });
  }
  openModal() {
    const initialState = {
      data: "Test Data"
    };
    this.modalRef = this.modalService.show(ForgotPasswordDialogComponent, { class: 'modal-dialog modal-dialog-centered modal-sm' });
  }
  closeNotesForm() {
    document.getElementById("myFilterForm").style.display = "none";
  }
  openFilterForm() {
    document.getElementById("myFilterForm").style.display = "block";
  }
  downloadFile(url: string) {
    var url = url + "?" + Math.random();
    window.location.href = url;
    this.closeNotesForm();
  }
  getOS() {
    var uA = navigator.userAgent || navigator.vendor;
    if ((/iPad|iPhone|iPod/.test(uA)) || (uA.includes('Mac') && 'ontouchend' in document)) return 'iOS';

    var i, os = ['Windows', 'Android', 'Unix', 'Mac', 'Linux', 'BlackBerry'];
    for (i = 0; i < os.length; i++) if (new RegExp(os[i], 'i').test(uA)) return os[i];
  }
}